export interface MessageItem {
    title?: string;
    message: string;
    iconImg?: string;
}

export enum InfoBoxType {
    Danger = 'Danger',
    Warning = 'Warning',
    Info = 'Info',
}

export enum flashTypes {
    error = 'error',
    warning = 'warning',
    info = 'info',
    success = 'success',
}
